import { ApprovalMode } from './global.model';

export function isApprovalMode(value: unknown): value is ApprovalMode {
	return value === 'disabled' || value === 'simple' || value === 'advanced';
}

export function resolveApprovalMode(value: unknown): ApprovalMode {
	return isApprovalMode(value) ? value : 'disabled';
}

export function isApprovalEnabled(value: unknown): boolean {
	return resolveApprovalMode(value) !== 'disabled';
}

export function isSimpleApprovalMode(value: unknown): boolean {
	return resolveApprovalMode(value) === 'simple';
}

export function isAdvancedApprovalMode(value: unknown): boolean {
	return resolveApprovalMode(value) === 'advanced';
}
